module.exports = __webpack_public_path__ + "media/assets/avia/ticket/bullet-point-87674b166a3e60c345e3859c47b0a85f.svg";